import tenantConstants from '@constants';
import React from 'react';
import QRCode from 'react-qr-code';
import { useTranslation } from 'react-i18next';
import { Icon } from '../../../../components/common';
import { isHttpUrl } from '../../../../utility/utility';
import { Band } from './RegaDetailBand.styled';
import { v2Color } from '@theme/v2';

const RegaDetailBand = ({ typeLabel, price, adLicense, location, area, url, onRegaClick = () => {} }) => {
  const { t } = useTranslation();

  return (
    <Band>
      <div className="summary">
        <p className="label">{t('REGA Details')}</p>
        {typeLabel ? <p className="type">{typeLabel}</p> : null}
        {price != null && price !== '' && (
          <p className="price">
            {tenantConstants.CURRENCY_SYMBOL()} {price}
          </p>
        )}
      </div>

      <div className="info">
        {adLicense && (
          <div className="row">
            <Icon icon="PiSealCheckFill" color={v2Color('#006169')} size={18} />
            <span>
              <span className="lbl">{t('Ad License:')} </span>
              <span className="val">{adLicense}</span>
            </span>
          </div>
        )}
        {location && (
          <div className="row">
            <Icon icon="FaMapMarkerAlt" color={v2Color('#006169')} size={16} />
            <span>{location}</span>
          </div>
        )}
        {area != null && area !== '' && (
          <div className="row">
            <Icon icon="PiStackSimpleFill" color={v2Color('#006169')} size={16} />
            <span>
              {area} {t('Sq. M.')}
            </span>
          </div>
        )}
      </div>

      {isHttpUrl(url) && (
        <div className="qr">
          <a href={url} target="_blank" rel="noopener noreferrer" onClick={() => onRegaClick(true)}>
            <QRCode size={56} value={url} viewBox="0 0 256 256" />
          </a>
          <a href={url} target="_blank" rel="noopener noreferrer" className="rega-link" onClick={() => onRegaClick(false)}>
            {t('View Details on Rega')}
            <Icon icon="MdArrowOutward" size={14} color={v2Color('#006169')} />
          </a>
        </div>
      )}
    </Band>
  );
};

export default RegaDetailBand;
